import * as React from 'react';

interface AlertContextType {
    error: React.ReactNode;
    setError: React.Dispatch<React.SetStateAction<React.ReactNode>>;
    warning: React.ReactNode;
    setWarning: React.Dispatch<React.SetStateAction<React.ReactNode>>;
    visible: boolean;
    setVisible: React.Dispatch<React.SetStateAction<boolean>>;
    successMessage: React.ReactNode;
    setSuccessMessage: React.Dispatch<React.SetStateAction<React.ReactNode>>;
    redirectUrl: string | null;
    setRedirectUrl: React.Dispatch<React.SetStateAction<string | null>>;
}

export const AlertContext = React.createContext<AlertContextType>({
    error: '',
    setError: () => {},
    warning: '',
    setWarning: () => {},
    visible: false,
    setVisible: () => {},
    successMessage: '',
    setSuccessMessage: () => {},
    redirectUrl: null,
    setRedirectUrl: () => {},
});

export const AlertProvider: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
    const [error, setError] = React.useState<React.ReactNode>('');
    const [warning, setWarning] = React.useState<React.ReactNode>('');
    const [visible, setVisible] = React.useState<boolean>(false);
    const [successMessage, setSuccessMessage] = React.useState<React.ReactNode>('');
    const [redirectUrl, setRedirectUrl] = React.useState<string | null>(null);

    // Memoize the value to prevent unnecessary re-renders
    const contextValue = React.useMemo(
        () => ({
            error,
            setError,
            warning,
            setWarning,
            visible,
            setVisible,
            successMessage,
            setSuccessMessage,
            redirectUrl,
            setRedirectUrl,
        }),
        [error, warning, visible, successMessage, redirectUrl]
    );

    return (
        <AlertContext.Provider value={contextValue}>
            {children}
        </AlertContext.Provider>
    );
};
